var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23.9996C19.1274 23.9996 24.5 18.627 24.5 11.9996C24.5 5.37219 19.1274 -0.000396729 12.5 -0.000396729C5.87258 -0.000396729 0.5 5.37219 0.5 11.9996C0.5 18.627 5.87258 23.9996 12.5 23.9996Z",
    fill: "#007AB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6699 12.9654V17.9127H16.8016V13.297C16.8016 12.138 16.3874 11.3465 15.3489 11.3465C14.5563 11.3465 14.0855 11.8794 13.8776 12.3953C13.8021 12.5797 13.7826 12.8358 13.7826 13.0944V17.9125H10.9141C10.9141 17.9125 10.9526 10.0949 10.9141 9.2857H13.7828V10.5082C13.7771 10.5178 13.7689 10.5272 13.7638 10.5364H13.7828V10.5082C14.164 9.92165 14.8438 9.08312 16.368 9.08312C18.2551 9.08312 19.6699 10.3161 19.6699 12.9654ZM7.91332 5.12726C6.93211 5.12726 6.29016 5.77135 6.29016 6.61758C6.29016 7.44584 6.9135 8.10854 7.87567 8.10854H7.89428C8.89475 8.10854 9.5168 7.44584 9.5168 6.61758C9.49776 5.77135 8.89475 5.12726 7.91332 5.12726ZM6.46065 17.9127H9.32813V9.2857H6.46065V17.9127Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.43aaa3ee5ff71ed35b06ad4cbbf73810.svg";
export { ForwardRef as ReactComponent };